import compareDates from '../helpers/CompareDates';

export default {
    methods: {
        sort(items: Array<object>, index: string | null, isDescending: boolean) {

            // Return items as is when not sorted
            if (!index) return items;

            // _at assume it is date field
            if (/_at/.test(index)) {

                items.sort((a: Object, b: Object) => {

                    if (isDescending) {
                        return compareDates(b[index], a[index]);

                    } else {
                        return compareDates(a[index], b[index]);
                    }
                });
                return items;
            }

            // No data just return unsorted
            if (!items[0]) return items;

            // Find first non null value
            let matchValue = items.find( (row: object) => {
                 return row[index]!==null;
            });

            // If all null just return
            if (!matchValue) {
                return items;
            }

            // First value numeric
            if (/[0-9]+(\.[0-9]+)?/.test(matchValue[index])) {

                items.sort(function (a, b) {
                    if (isDescending) {
                        return b[index] - a[index];
                    } else {
                        return a[index] - b[index];
                    }
                });
                return items;
            }

            // Default alpha sort
            items.sort(function (a, b) {
                if (isDescending) {
                    if (a[index] > b[index]) return -1;
                    if (a[index] < b[index]) return 1;
                    return 0;
                } else {
                    if (a[index] < b[index]) return -1;
                    if (a[index] > b[index]) return 1;
                    return 0;
                }
            });
            return items;
        },
    }
}